/**
 * PlatformVersionWrapper previously contained auto-refresh logic that would
 * reload the browser when the running app version fell behind the server's
 * version (major → force-reload, minor → notification). This was disabled
 * because users reported random, disruptive page refreshes. The component is
 * kept as a pass-through so the three experience entry-points
 * (OfficeExperience, TechnicianExperience, AccountExperience) don't need to
 * be touched.
 *
 * The ConnectivityProvider still polls /platform-version for health-check
 * purposes — that is unaffected by this change.
 */
export const PlatformVersionWrapper = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>
}
